<!-- ITP2-14993: none of it for a magic-link-only session, and none of it before the session is known. -->
<ng-container *ngIf="enabled$ | async">
    <app-incoming-call></app-incoming-call>
    <app-call-bar></app-call-bar>
    <!-- A video call (ITP-E-182-01): the card replaces the bar in the tab that holds the call; only one of them shows. A
         group call's participants are on the bar (ITP-E-182-04): there is no separate panel.
         ITP-E-185-03: every call this tab holds is drawn here, by one compact call view — the voice strip where the bar
         sits, turning into the card on Camera or Share; the bar keeps the outcome, the passive bar and the blocked
         microphone. -->
    <app-video-call-card></app-video-call-card>
    <!-- Recording with everyone's consent (ITP-E-172-02): the consent dialog, the Recording indicator, the host's notices. -->
    <app-recording-consent></app-recording-consent>
    <!-- Missed calls and "tried to call you" (ITP-E-171-01): banners, not an overlay. -->
    <app-missed-call-banner></app-missed-call-banner>
</ng-container>
